import template from './date_range_picker.html.slim';
import controller from './date_range_picker_controller';

angular.module('wbComponents').directive('wbDateRangePicker', () =>
  ({
    replace: true,
    restrict: 'E',
    controllerAs: 'ctrl',
    bindToController: true,
    scope: {
      active: '=',
      range: '=',
      startDate: '=',
      endDate: '='
    },
    controller,
    templateUrl: template,

    link($scope, $el, $attrs) {
      $scope.ctrl.isRange = ($attrs.range != null);
      $scope.ctrl.isDate = ($attrs.date != null);

      return $('html').on('click', function(e) {
        if ($(e.target).closest($el).length) { return; }
        $scope.ctrl.active = false;
      });
    }
  })
);